import React from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { Pick } from 'src/models';

type PicksTableProps = {
  picks: Pick[];
};

const PicksTable = ({ picks }: PicksTableProps): JSX.Element => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ width: '100%' }} aria-label='simple table' size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Score</TableCell>
            <TableCell align='right'>Player</TableCell>
            <TableCell align='right'>Player</TableCell>
            <TableCell align='right'>Games</TableCell>
            <TableCell align='right'>Winner</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {picks.map((pick) => (
            <TableRow
              key={pick.gamePk}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component='th' scope='row'>
                {`${pick.score1} - ${pick.score2}`}
              </TableCell>
              <TableCell align='right'>{pick.homePlayer.fullName}</TableCell>
              <TableCell align='right'>{pick.awayPlayer.fullName}</TableCell>
              <TableCell align='right'>{pick.numOfGames}</TableCell>
              <TableCell align='right'>{pick.team.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PicksTable;
